import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import SaveLesson from './SaveLesson'

import * as lessonBuilderActions from '../../../../../store/actions/lessonBuilder'

export default connect(
  (state) => ({
    lesson: state.lessonBuilder,
    courseId: state.courseBuilder.courseId
  }),
  (dispatch) => ({
    lessonBuilderActions: bindActionCreators(lessonBuilderActions, dispatch)
  })
)(SaveLesson)
